import { createFeatureSelector } from '@ngrx/store';
import { AgingPeriodStates } from '../states';
import { agingPeriodFeatureKey } from '../reducers/aging-period.reducers';

export const selectAgingPeriodFeature = createFeatureSelector<AgingPeriodStates>(agingPeriodFeatureKey);

export const selectAgingPeriod = (state: AgingPeriodStates) => state.agingPeriod.selectedAgingPeriod;
export const selectLines = (state: AgingPeriodStates) => state.agingPeriod.lines;
